import {CustomerStories, type CustomerStoriesProps} from '../../generic/CustomerStories/CustomerStories'

import Styles from './CustomerStoriesSection.module.css'

export type CustomerStoriesSectionProps = CustomerStoriesProps

export const defaultProps: Partial<CustomerStoriesSectionProps> = {}

export const CustomerStoriesSection = (props: CustomerStoriesSectionProps) => {
  const initializedProps: CustomerStoriesSectionProps = {...defaultProps, ...props}

  return (
    <div className={Styles['CustomerStoriesSection']}>
      <CustomerStories {...initializedProps} />
      <div className={Styles['CustomerStoriesSection__Spacer']} />
    </div>
  )
}
